import { render } from "./TZHeader.vue?vue&type=template&id=8d0542c2&scoped=true"
import script from "./TZHeader.vue?vue&type=script&lang=js"
export * from "./TZHeader.vue?vue&type=script&lang=js"

import "./TZHeader.vue?vue&type=style&index=0&id=8d0542c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0542c2"]])

export default __exports__